import './App.css';
import JarvisVoice from './components/JarvisVoice';

function App() {
  return (
    <div className="App">
      <JarvisVoice />
    </div>
  );
}

export default App;